// Configuration du menu affiché aux utilisateurs (élèves) — labels, routes, icônes.
// Consommée par Navbarfooter, DesktopSidebar et Drawer.
const userMenu = [
    {
        path: '/accueil',
        label: 'Accueil',
        icon: 'home',
        isActive: (pathname) => pathname === '/accueil',
    },
    {
        path: '/portefeuille',
        label: 'Portefeuille',
        icon: 'wallet',
        isActive: (pathname) => pathname.startsWith('/portefeuille') && !pathname.startsWith('/portefeuille_menu'),
    },
    {
        path: '/portefeuille_menu',
        label: 'Marchés',
        icon: 'markets',
        isActive: (pathname) => pathname.startsWith('/portefeuille_menu'),
    },
    {
        path: '/classement',
        label: 'Classement',
        icon: 'trophy',
        isActive: (pathname) => pathname === '/classement',
    },
    {
        path: '/profil',
        label: 'Profil',
        icon: 'user',
        isActive: (pathname) => pathname === '/profil',
    },
];

export default userMenu;
